type DataLayerEvent<T extends string, P = undefined> = {
  eventName: T;
  payload?: P;
};

type LoginMethods = 'naver' | 'kakao' | 'google' | 'apple' | 'normal' | string;

/** 유저정보 관련*/
type LoginAttempt = DataLayerEvent<'login_attempt', null>;

type LoginSuccess = DataLayerEvent<
  'login_success',
  {
    login_social_method: LoginMethods;
  }
>;

type UserIDXCreated = DataLayerEvent<
  'user_idx_created',
  {
    user_idx: number | null;
  }
>;

type UserIDXPurged = DataLayerEvent<
  'user_idx_purged',
  {
    user_idx: null;
  }
>;

/** 회원가입 */
type AuthMethodSeletion = DataLayerEvent<
  'auth_method_select',
  {
    auth_type: 'phone' | 'ipin' | 'easy' | string;
  }
>;

type AuthFail = DataLayerEvent<
  'auth_fail',
  {
    auth_type: 'phone' | 'ipin' | 'easy' | string;
  }
>;

type AuthSuccess = DataLayerEvent<
  'auth_success',
  {
    auth_type: 'phone' | 'ipin' | 'easy' | string;
  }
>;

type SignupSuccess = DataLayerEvent<
  'signup_success',
  {
    signup_social_method: LoginMethods;
  }
>;

/** 시청 */

type DonationInsufficientAlert = DataLayerEvent<'donation_insufficient_alert'>;

type DonationInsufficientConfirm = DataLayerEvent<
  'donation_insufficient_alert_confirm',
  {
    needed_amount: number;
    current_balance: number;
  }
>;

type LiveStreamWatch = DataLayerEvent<'play_id_changed'>;
// cancel
type DonationInsufficientCancel = DataLayerEvent<'donation_insufficient_alert_cancel'>;

type DatalayerPushEvents =
  // 로그인
  | LoginAttempt
  | LoginSuccess
  | UserIDXCreated
  | UserIDXPurged

  // 회원가입
  | AuthMethodSeletion
  | AuthFail
  | AuthSuccess
  | SignupSuccess
  // 후원
  | DonationInsufficientAlert
  | DonationInsufficientConfirm
  | DonationInsufficientCancel
  // 결제
  | DataLayerEvent<'store_modal_view'> // 상점 모달 마운트
  | DataLayerEvent<'purchase_modal_view'> // 결제 모달 마운트
  | DataLayerEvent<'purchase_modal_view_success'>

  // 시청
  | LiveStreamWatch;

type DataLayerEventMap = {
  [E in DatalayerPushEvents as E['eventName']]: Extract<DatalayerPushEvents, { eventName: E['eventName'] }>['payload'];
};

export function updateDataLayer<K extends keyof DataLayerEventMap>(eventName: K, payload?: DataLayerEventMap[K]): void {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...payload,
    });
  }
}
